module.exports = __webpack_public_path__ + "img/pc.9ad4d173.svg";